// eslint-disable-next-line @typescript-eslint/naming-convention
export const KEY_FORM = 'form';

export const enum EnumForm {
	Document = 'SDO-DOCUMENTO',
	Template = 'SDO-PLANTILLA',
	Notificacion = 'SDO-NOTIFICACION',
	Herramienta = 'SDO-DICCIONARIO-DATOS',
}
